import { render, staticRenderFns } from "./08_ClientApprovalForm.vue?vue&type=template&id=edac2d20&scoped=true&"
import script from "./08_ClientApprovalForm.vue?vue&type=script&lang=js&"
export * from "./08_ClientApprovalForm.vue?vue&type=script&lang=js&"
import style0 from "./08_ClientApprovalForm.vue?vue&type=style&index=0&id=edac2d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edac2d20",
  null
  
)

export default component.exports